import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Budget_Entity } from "../../entities/budget";
import { filmsApi } from "../api/filmsApi";

const budgetsAdapter = createEntityAdapter<Budget_Entity>();
const initialState = budgetsAdapter.getInitialState();

export const budgetEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getBudgets: build.query<EntityState<Budget_Entity>, void>({
      query: () => `budgets`,
      transformResponse: (responseData: Budget_Entity[]) => {
        return budgetsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["budgets"],
    }),
    getBudget: build.query<Budget_Entity, number>({
      query: (id) => `budgets/${id}`,
      providesTags: (result, error, id) => [{ type: "budgets", id }],
    }),
    createBudget: build.mutation<Budget_Entity, Partial<Budget_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `budgets`,
      }),
      invalidatesTags: ["budgets"],
    }),
    updateBudget: build.mutation<
      void,
      { id: number; body: Partial<Budget_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `budgets/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "budgets", id },
        "budgets",
      ],
    }),
    deleteBudget: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `budgets/${id}`,
      }),
      invalidatesTags: ["budgets"],
    }),
  }),
});

export const {
  useGetBudgetQuery,
  useGetBudgetsQuery,
  useCreateBudgetMutation,
  useDeleteBudgetMutation,
  useUpdateBudgetMutation,
} = budgetEndpoints;

export default budgetEndpoints;
